<template>
  <div class="contents">
    <VitePwaManifest />
    <Title>StageZero</Title>
    <NuxtLayout />
    <LazyToasts />
    <LazyRouterLoading />
  </div>
</template>
